import React from "react";
import {Link, useLocation} from "react-router-dom";
import { HashLink } from 'react-router-hash-link';
import { isSamePageAnchor, smoothScrollTo } from './smoothScroll';


const Arrow = ({variant}) => {
    let color = variant === 'dark-primary' ? "#182553" : "white";

    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="13" viewBox="0 0 12 13" fill="none">
            <path d="M5.475 11.9746C5.3375 11.8371 5.2655 11.6621 5.259 11.4496C5.253 11.2371 5.31875 11.0621 5.45625 10.9246L9.13125 7.24961H0.75C0.5375 7.24961 0.35925 7.17761 0.21525 7.03361C0.0717501 6.89011 0 6.71211 0 6.49961C0 6.28711 0.0717501 6.10886 0.21525 5.96486C0.35925 5.82136 0.5375 5.74961 0.75 5.74961H9.13125L5.45625 2.07461C5.31875 1.93711 5.253 1.76211 5.259 1.54961C5.2655 1.33711 5.3375 1.16211 5.475 1.02461C5.6125 0.887109 5.7875 0.818359 6 0.818359C6.2125 0.818359 6.3875 0.887109 6.525 1.02461L11.475 5.97461C11.55 6.03711 11.6033 6.11511 11.6348 6.20861C11.6658 6.30261 11.6813 6.39961 11.6813 6.49961C11.6813 6.59961 11.6658 6.69336 11.6348 6.78086C11.6033 6.86836 11.55 6.94961 11.475 7.02461L6.525 11.9746C6.3875 12.1121 6.2125 12.1809 6 12.1809C5.7875 12.1809 5.6125 12.1121 5.475 11.9746Z" fill={color}/>
        </svg>
    )
}


const Button = ({to, label, variant, isHashLink, className = '', target}) => {
    const relAttr = target === '_blank' ? 'noopener noreferrer' : undefined;
    const { pathname } = useLocation();
    // same-page anchors glide; cross-page ones keep HashLink's instant jump
    const scrollBehaviour = isSamePageAnchor(to, pathname) ? smoothScrollTo : undefined;
    const baseStyle = "btn w-full text-center group-hover:text-left p-3 rounded-lg md:w-48 group flex justify-center items-center relative overflow-hidden transition-all duration-500 ease-in-out cursor-pointer gap-2.5";
    const styles = {
        "light-secondary": `${baseStyle} border-primaryBrand bg-transparent border border-solid hover:bg-primaryBrand`,
        "dark-primary": `${baseStyle} bg-white`,
        "dark-secondary": `${baseStyle} border-white bg-transparent border border-solid`,
        "light-primary": `${baseStyle} bg-primaryBrand`
    }

    const gradientStyle = {
        "light-secondary": "group-hover:bg-btnHover",
        "dark-primary": "group-hover:bg-btnHover",
        "dark-secondary": "group-hover:bg-btnHover2",
        "light-primary": "group-hover:bg-btnHover"
    }

    const labelStyle = {
        "light-secondary": "text-primaryBrand group-hover:text-white",
        "dark-primary": "text-primaryBrand",
        "dark-secondary": "text-white",
        "light-primary": "text-white"
    }


    const linkClassName = `${styles[variant]} ${className}`.trim();

    return (
        isHashLink ? (
            <HashLink to={to} target={target} rel={relAttr} scroll={scrollBehaviour} className={linkClassName}>
                <div className={`z-0 absolute top-0 left-0 w-full h-full rounded-lg opacity-0 group-hover:opacity-100 transition-opacity duration-500 ease-in-out ${gradientStyle[variant]}`}></div>
                <span className={`z-10 ` + labelStyle[variant]}>{label}</span>
                <span className="icon-hover"><Arrow variant={variant} /></span>
            </HashLink>
        ) : (
            <Link to={to} target={target} rel={relAttr} className={linkClassName}>
                <div className={`z-0 absolute top-0 left-0 w-full h-full rounded-lg opacity-0 group-hover:opacity-100 transition-opacity duration-500 ease-in-out ${gradientStyle[variant]}`}></div>
                <span className={`z-10 ` + labelStyle[variant]}>{label}</span>
                <span className="icon-hover z-10"><Arrow variant={variant} /></span>
            </Link>
        )
    )
}

export default Button;